import tinycolor from "tinycolor2";
import jssVariables from "../../jss_setup";

export const hotelSearchStrip = {
  SearchStripDefault: {
    background: jssVariables.colors.base_color,
    smallscreen: {
      background: jssVariables.colors.base_color,
    },
  },
};

export const hotelFiltersBar = {
  FiltersBar: {
    background: "#8EA2B1",
    smallscreen: {
      color: "white",
    },
  },
};

export const hotelSearchStripDest = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const hotelSearchStripDates = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const hotelSearchStripPax = {
  icon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const hotelStyles = {
  RatingPanel: {
    iconFilled: {
      color: jssVariables.colors.secondary_color,
    },
    iconEmpty: {
      color: jssVariables.colors.secondary_color,
    },
  },
};

export const hotelAddressStyles = {
  mapIcon: {
    color: jssVariables.colors.secondary_color,
  },
};

export const hotelBottomContainer = {
  priceTxt: {
    color: jssVariables.colors.secondary_color,
  },
  Price: {
    color: jssVariables.colors.secondary_color,
  },
};

export const HotelMeta = {
  gradientBackground: {
    background: `linear-gradient(180deg, ${tinycolor(
      jssVariables.colors.secondary_color
    )
      .lighten(40)
      .toRgbString()} 0%, #FFFFFF 100%)`,
  },
  stripeBtm: {
    background: jssVariables.colors.secondary_color,
  },
};

export const hotelSearchStripLoader = {
  Loader: {
    color: "white",
  },
  loadingIcon: {
    color: "white",
  },
};
